<span class="status-badge" [ngClass]="'status-badge--' + tipo"
    [matTooltip]="tooltip || ''" [matTooltipShowDelay]="600">
    <span class="status-badge__dot"></span>
    <span class="status-badge__label">{{ label }}</span>
    <span class="status-badge__detalhe" *ngIf="detalhe">{{ detalhe }}</span>
</span>
